import Vue from "vue";
import axios from "axios";

export default class HttpService extends Vue {
     postBerekenIndicatief(requestBody) {
        return axios.post(this.baseEnergieApiUrl + 'berekenIndicatief', requestBody,
            {
                headers: {
                    ['x-apikey']: process.env.VUE_APP_X_API_KEY,
                }
            })
    }
}